import React, { useState, useRef, useEffect } from 'react';
import { VStack, Pagination, Flex } from '@wegroup/design-system';
import {
  InsurancePolicyOverviewProps,
  POLICIES_PAGE_SIZE,
} from '../InsurancePolicyOverview';
import InsurancePolicyItem from './InsurancePolicyItem';

const InsurancePolicyVirtualList: React.FC<InsurancePolicyOverviewProps> = ({
  insurancePolicies,
  renderCustomActions,
  ...props
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const listRef = useRef<HTMLDivElement>(null);
  const totalPages = Math.ceil(insurancePolicies.length / POLICIES_PAGE_SIZE);
  const startIndex = (currentPage - 1) * POLICIES_PAGE_SIZE;
  const endIndex = startIndex + POLICIES_PAGE_SIZE;
  const currentItems = insurancePolicies.slice(startIndex, endIndex);
  const scrollToTop = () => {
    listRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [totalPages]);

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
      scrollToTop();
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
      scrollToTop();
    }
  };

  const handlePageClick = (page: number) => {
    setCurrentPage(page);
    scrollToTop();
  };

  return (
    <VStack align="stretch" ref={listRef} spacing="3">
      <VStack align="stretch" spacing="3">
        {currentItems.map((insurancePolicy, index) => (
          <InsurancePolicyItem
            key={startIndex + index}
            insurancePolicy={insurancePolicy}
            index={startIndex + index}
            isDragDisabled
            customActions={renderCustomActions?.(insurancePolicy)}
            {...props}
          />
        ))}
      </VStack>
      {totalPages > 1 && (
        <Flex justify="flex-end">
          <Pagination
            onNext={handleNextPage}
            onPrev={handlePrevPage}
            onPageClick={handlePageClick}
            pages={totalPages}
            currentPage={currentPage}
          />
        </Flex>
      )}
    </VStack>
  );
};

export default InsurancePolicyVirtualList;
